import {
  RECKON_ADMIN_EMAILS,
  isReckonAdmin,
} from '@/lib/admin/permissions';

const COMMENT_ADMIN_EMAILS = RECKON_ADMIN_EMAILS;

function isCommentAdmin(user) {
  return isReckonAdmin(user);
}

function ownsComment(user, comment) {
  return Boolean(user?.uid && comment?.authorUid === user.uid);
}

function canEditComment(user, comment) {
  return ownsComment(user, comment);
}

function canDeleteComment(user, comment) {
  return ownsComment(user, comment) || isCommentAdmin(user);
}

export {
  COMMENT_ADMIN_EMAILS,
  canDeleteComment,
  canEditComment,
  isCommentAdmin,
  ownsComment,
};
